<template>
  <div class="benchmark-select">
    <div>
      <a @click="open = !open"
        ><span class="fa fa-plus-circle"></span> {{ label }}</a
      >
    </div>
    <section v-if="open" class="modal-content">
      <h2><span class="fa fa-list"></span> {{ labelQuickSelection }}</h2>
      <div class="quick">
        <ul v-for="group in benchmarkGroups" :key="group.caption">
          <li>{{ group.caption }}</li>
          <li v-for="benchmark in group.benchmarks" :key="benchmark.notation">
            <a @click="addBenchmark(benchmark)"
              ><span class="fa fa-plus-circle"></span> {{ benchmark.label }}</a
            >
          </li>
        </ul>
      </div>
      <div class="cancel-button">
        <a @click="open = false">{{ labelCancel }}</a>
      </div>
    </section>
  </div>
</template>

<script>
import { defaultBenchmarks } from "../util/chart/defaultBenchmarks";
import { eventBus } from "../util/instances";
import "@fortawesome/fontawesome-free/js/all";

const getBenchmarks = () => [{ caption: "", benchmarks: defaultBenchmarks }];

export default {
  name: "chart-control-benchmark-quickselect",
  props: {
    channel: {
      type: String,
      required: false,
      default: "1"
    },
    benchmarkGroups: {
      type: Array,
      required: false,
      default: getBenchmarks
    },
    label: {
      type: String,
      required: false,
      default: "Compare"
    },
    labelQuickSelection: {
      type: String,
      required: false,
      default: "Quick select"
    },
    labelCancel: {
      type: String,
      required: false,
      default: "Cancel"
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    addBenchmark(benchmark) {
      eventBus.$emit(`${this.channel}:changeBenchmark`, benchmark);
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.2em;
  margin: 1em;
  display: flex;
}

h2 svg {
  margin-right: 5px;
}

a {
  cursor: pointer;
}

ul {
  padding: 0;
}

.modal-content {
  position: absolute;
  background: #fff;
  padding: 1em 0.5em 1em 0.5em;
  z-index: 100;
  width: inherit;
}

div.quick ul {
  list-style: none;
  margin: 0 1em 1em 1em;
}

div.quick ul li {
  list-style-type: none;
  margin-left: -5px;
}

div.quick ul li a {
  display: block;
  padding: 5px 0 5px 5px;
}

div.quick ul li:first-child {
  padding-left: 5px;
  font-weight: bold;
  font-family: "Roboto Condensed", sans-serif;
}

.cancel-button {
  margin-top: 1em;
  margin-right: 1em;
  text-align: right;
  font-size: 1.2em;
}
</style>
